import React, { useState } from 'react'
import { Tooltip } from '@mui/material'

import { Chip, Icon } from '~components/internal'
import { VariableInsertMenu } from '~components/internal/VariableInsertMenu'

import { type PersonalizationVariable, VARIABLE_INSERT_TOOLTIP } from '.'

interface VariableInsertButtonProps {
  variables: PersonalizationVariable[]
  onVariableInsert: (varKey: string) => void
  /** Runs on click before the menu opens. Return true if the click was already
   * handled (e.g. a text selection was converted into a variable) to keep the
   * menu from opening. */
  interceptClick?: () => boolean
}

const VariableInsertButton: React.FC<VariableInsertButtonProps> = ({
  variables,
  onVariableInsert,
  interceptClick,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const handleInsert = (varKey: string): void => {
    onVariableInsert(varKey)
    setAnchorEl(null)
  }

  if (variables.length === 0 && !interceptClick) return null

  return (
    <>
      <Tooltip title={VARIABLE_INSERT_TOOLTIP}>
        <span>
          <Chip
            icon={<Icon name='personAdd' />}
            label='Insert Variable'
            variant='outlined'
            onClick={(e) => {
              if (interceptClick?.()) return
              setAnchorEl(e.currentTarget)
            }}
          />
        </span>
      </Tooltip>
      <VariableInsertMenu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        variables={variables}
        onVariableInsert={handleInsert}
      />
    </>
  )
}

export default VariableInsertButton
